import { useRef, useEffect } from 'react';
import { useAudioPlayerStore } from '../../stores/audioPlayerStore';
import { useThemeStore } from '../../stores/themeStore';

interface Props {
  src: string;
  className?: string;
}

/**
 * 全局单例播放器：同一时间只允许一个音频播放。
 * 替代原生 <audio controls>，接口完全兼容。
 */
export default function AudioPlayer({ src, className }: Props) {
  const ref = useRef<HTMLAudioElement>(null);
  const setCurrentAudio = useAudioPlayerStore(s => s.setCurrentAudio);
  const mode = useThemeStore(s => s.mode);


  const isDark =
    mode === 'dark' ||
    (mode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handlePlay = () => setCurrentAudio(el);
    el.addEventListener('play', handlePlay);
    return () => el.removeEventListener('play', handlePlay);
  }, [setCurrentAudio]);

  return (
    <audio
      ref={ref}
      controls
      src={src}
      style={{ colorScheme: isDark ? 'dark' : 'light' }}
      className={className ?? 'w-full h-8'}
    />
  );
}
